import * as angular from 'angular';

import { IRootScope } from '../../../IRootScope';
import * as events from '../../../common';
import { ComponentDefinition } from '../../../models';
import { IKeycloakService } from '@services/general/keycloak.service';
import { IAuthenticationService } from '@services/general';

class UserZoneController implements angular.IComponentController {
    isMobileMode: boolean;
    setMobileMode: (value: { isMobileMode: boolean }) => void;
    userName: string;

    static $inject = ['$scope', '$rootScope', '$state', '$translate', 'authenticationService', 'keycloakService'];
    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _authenticationService: IAuthenticationService,
        private _keycloakService: IKeycloakService
    ) {}

    $onInit() {
        this._$scope.$watch(
            () => this._authenticationService.authentication.userName,
            () => {
                this.userName = this._authenticationService.authentication.userName;
            }
        );
    }

    async changePassword() {
        if (this._keycloakService.isKeycloakConfigured()) {
            await this._keycloakService.changePassword();
        } else {
            this._$state.go('passwordChange');
        }
    }

    roles() {
        return this._authenticationService.authentication.roles;
    }

    superAdmin() {
        return this._authenticationService.authentication.isSuperAdmin;
    }

    logout() {
        if (this._$rootScope.isEditMode === undefined || this._$rootScope.isEditMode === false) {
            this._$rootScope.$broadcast(events.logout);
        }
    }

    setLanguage(key: string) {
        this._$translate.use(key);
    }

    navigateTo(state: string) {
        if (this._$rootScope.isEditMode === undefined || this._$rootScope.isEditMode === false) {
            if (state === 'user') {
                this._$state.go(state, { userName: this.userName });
            } else {
                this._$state.go(state);
            }
        }
    }

    toggleMobileMode() {
        if (this.setMobileMode) {
            this.setMobileMode({ isMobileMode: !this.isMobileMode });
        }
    }
}

export const wtUserZone: ComponentDefinition = {
    componentId: 'wtUserZone',
    controller: UserZoneController,
    template: require('./userZone.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        isMobileMode: '<?',
        setMobileMode: '&?'
    }
};
